module.exports = __webpack_public_path__ + "static/media/fingerprint.80ef1855.svg";